import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "proposal_Ei9l7",
  "use": "proposal_Ei9l7-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" stroke=\"currentColor\" fill=\"none\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" id=\"proposal_Ei9l7\">\n    <path d=\"M14 3V7H18\" />\n    <path d=\"M14 3H5V21H19V7\" />\n    \n    <path d=\"M12 17V17.01\" />\n    <path d=\"M12 14C13.6569 14 15 12.6569 15 11C15 9.34315 13.6569 8 12 8C10.3431 8 9 9.34315 9 11\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol